var uncurryThis = require('../internals/function-uncurry-this');

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/classof-raw.js